import { render, staticRenderFns } from "./UploadPlanilha.vue?vue&type=template&id=0c53c22e&lang=pug"
import script from "./UploadPlanilha.vue?vue&type=script&lang=js"
export * from "./UploadPlanilha.vue?vue&type=script&lang=js"
import style0 from "./UploadPlanilha.vue?vue&type=style&index=0&id=0c53c22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports